import React from 'react'

import PricingSection from '../components/PricingSection'

// The membership pricing page is an authenticated step of the subscribe flow.
// It renders inside the header-only app chrome provided by the
// civic_lens_subscribe layout, so this page renders only the pricing content —
// no marketing Header/Footer of its own.
const MembershipPage = ({ membershipPath, currentUser, currentPlan }) => {
  return <PricingSection membershipPath={membershipPath} currentUser={currentUser} currentPlan={currentPlan} />
}

export default MembershipPage
